export const ApplicantsFull = 'applicants_full'
export const NotEligible = 'not_eligible'
